// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/index'
import fastclick from 'fastclick'
import '@/styles/index.scss'
import '@/styles/var.scss'
import '@/styles/login.scss'
import http from '@/utils/request'
import https from '@/utils/https'
import './permission'

import '@/utils/rem.js'
import * as echarts from 'echarts'

//全局组件
import plugins from './components/plugins'

Vue.prototype.$echarts = echarts

Vue.prototype.$http = http
Vue.prototype.$https = https

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(plugins)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js